module.exports = __webpack_public_path__ + "assets/img/s1_tab1_m.d1bef2b6.png";